const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg1152"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      id="path1150"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M12 3.64A1.32 1.32 0 1 0 12 1a1.32 1.32 0 0 0 0 2.64m0 9.68a1.32 1.32 0 1 0 0-2.64 1.32 1.32 0 0 0 0 2.64M12 23a1.32 1.32 0 1 0 0-2.64A1.32 1.32 0 0 0 12 23"
    ></path>
  </svg>
);

export default SvgIcon;
